import { useEffect, useState } from 'react'

// Returns the id of the section currently crossing the middle of the viewport.
// Starts empty on the server and the first client render, then observes after mount.
export const useActiveSection = (sectionIds: string[]): string => {
    const [activeId, setActiveId] = useState('')
    const key = sectionIds.join('|')

    useEffect(() => {
        const elements = key
            .split('|')
            .map(id => document.getElementById(id))
            .filter((element): element is HTMLElement => element !== null)

        if (elements.length === 0) return

        const observer = new IntersectionObserver(
            entries => {
                const visible = entries.find(entry => entry.isIntersecting)
                if (visible) setActiveId(visible.target.id)
            },
            { rootMargin: '-45% 0px -50% 0px' }
        )

        elements.forEach(element => observer.observe(element))

        return () => observer.disconnect()
    }, [key])

    return activeId
}
